import CONSTANTS from "../../constants";
import fetchWithAuthorizationHeader from "../../helper/fetchWithAuthorizationHeader";
import { GcpCert, GcpCertRequest } from "../../types/gcpCert";

const { GCPCERTS_API_URL } = CONSTANTS

const createNewCert = async (newResource: GcpCertRequest): Promise<any> => {
  const response = await fetchWithAuthorizationHeader(`${GCPCERTS_API_URL}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      action: 'CREATE'
    },
    body: JSON.stringify(newResource) 
  })

  return response.json()
}

export default createNewCert